(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ds-aroma-banner"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ds-aroma-carousel')) {
  customElements.define('ds-aroma-carousel', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const track = this.querySelector('.ds-aroma-routes');
      const previous = this.querySelector('[data-aroma-previous]');
      const next = this.querySelector('[data-aroma-next]');
      const controls = this.querySelector('.ds-aroma-controls');
      if (!track || !previous || !next) return;
      const update = () => {
        const maximum = track.scrollWidth - track.clientWidth;
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maximum - 2;
        controls.hidden = maximum <= 2;
        track.tabIndex = maximum > 2 ? 0 : -1;
      };
      const move = direction => {
        const card = track.querySelector('.ds-aroma-route');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        track.scrollBy({
          left: direction * (card.getBoundingClientRect().width + gap),
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      };
      const options = { signal: this.abort.signal };
      previous.addEventListener('click', () => move(-1), options);
      next.addEventListener('click', () => move(1), options);
      track.addEventListener('scroll', update, { ...options, passive: true });
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ds-bespoke-perfumes"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ds-bespoke-carousel')) {
  customElements.define('ds-bespoke-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ds-bespoke__steps');
      this.slides = [...this.track.children];
      this.previous = this.querySelector('[data-bespoke-previous]');
      this.next = this.querySelector('[data-bespoke-next]');
      this.position = this.querySelector('.ds-bespoke__position');
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (!matchMedia('(max-width: 767px)').matches) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.move(event.key === 'ArrowLeft' ? -1 : 1);
        }
      }, options);
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this.track);
      this.update();
    }
    update() {
      this.index = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / Math.max(1, this.track.clientWidth))));
      this.previous.disabled = this.index === 0;
      this.next.disabled = this.index === this.slides.length - 1;
      const text = (this.index + 1) + ' / ' + this.slides.length;
      if (this.position.textContent !== text) this.position.textContent = text;
    }
    move(direction) {
      const index = Math.max(0, Math.min(this.slides.length - 1, this.index + direction));
      this.track.scrollTo({ left: index * this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    disconnectedCallback() {
      this.events?.abort();
      this.resize?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(() => {
  const android = /Android/i.test(navigator.userAgent);
  const preview = window.Shopify?.designMode && new URLSearchParams(window.location.search).get('ds_android_preview') === '1';
  document.documentElement.toggleAttribute('data-ds-android', android || preview);
  const selector = '.header__iconGroup [class*="WishlistHeader"][class*="HeartCounter"]';
  function syncFavoriteCount() {
    document.querySelectorAll(selector).forEach(counter => {
      const digits = counter.textContent.trim().replace(/[^0-9]/g, '');
      counter.dataset.dsEmpty = String(!digits || Number(digits) === 0);
    });
  }
  function startFavoriteCount() {
    syncFavoriteCount();
    new MutationObserver(syncFavoriteCount).observe(document.body, {
      childList: true, subtree: true, characterData: true
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startFavoriteCount, { once: true });
  } else {
    startFavoriteCount();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
